<template>
  <div class="news">
    <div class="title">
      <h3>
        <span @click="comBack()">
          <i class="el-icon-arrow-left"></i>
          {{
            id
              ? isExamine == 0 || isExamine == 2
                ? $t("news.viewnews")
                : $t("news.editNews")
              : $t("homepage.addnews")
          }}
        </span>
        <span class="num1"
          >{{ $t("common.required1") }}<i>*</i
          >{{ $t("common.required2") }}</span
        >
      </h3>
      <!-- <div class="internation">
        <button @click="sizeForm.language = 'zh_CN'">中文</button>
        <button @click="sizeForm.language = 'en_US'">English</button>
      </div> -->
    </div>

    <div class="formedata">
      <el-form
        ref="form"
        :disabled="isExamine == '2' || isExamine == '0' ? true : false"
        :model="sizeForm"
        :rules="rules"
        label-width="200px"
        size="mini"
      >
        <el-form-item :label="$t('news.newsNameCh') + ':'" prop="newsTitle">
          <el-input
            v-model="sizeForm.newsTitle"
            maxlength="50"
            :placeholder="$t('news.placeholder1')"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('news.zhaoyai') + ':'" prop="abstracts">
          <el-input
            v-model="sizeForm.abstracts"
            :rows="10"
            type="textarea"
            @input="inputArea"
          ></el-input>
          <p>
            {{ $t("common.inputarea1") }}<span>{{ currentLength }}</span>
            {{ $t("common.inputarea2", { Num: 60 }) }}
          </p>
        </el-form-item>
        <el-form-item :label="$t('news.coverPhoto') + ':'">
          <!-- <div :style="{ background: 'url(' + spliceUrl(toggleImg ? toggleImg :sizeForm.coverPhoto) + ')#f1f1f1 no-repeat top /contain' }" class="upload-logo">
            <img alt="删除" src="../../../static/icon_del.png" @click="deleteImg()"/>
					上传封面
					<el-upload
						drag
            class="upload-demo"
						ref="upload"
						:action="baseFileUrl"
						:headers="getToken()"
						name="file"
						:auto-upload="false"
						:on-success="handSuccess"
						list-type="picture-card"
						:on-error="handleError"
            :on-change="changeUpload"
            :show-file-list="false"
					>
						<div class="el-upload__text">选择文件</div>
					</el-upload>
          </div> -->
          <div class="imgBox">
            <ul>
              <li v-for="(item, index) in photoCoverList" :key="index">
                <div
                  :style="{
                    background:
                      'url(' + item.url + ')#f1f1f1 no-repeat center /contain',
                  }"
                  class="upload-logo"
                >
                  <img
                    v-if="
                      isExamine == '-1' ||
                      isExamine === '-2' ||
                      isExamine === ''
                    "
                    alt="删除"
                    src="../../../static/icon_del.png"
                    @click="item.url = ''"
                  />

                  <el-upload
                    ref="coverVideo"
                    :action="baseFileUrl"
                    :before-upload="beforeUpload"
                    :headers="getToken()"
                    :on-success="handSuccess"
                    :show-file-list="false"
                  >
                    <el-button
                      v-if="
                        isExamine == '-1' ||
                        isExamine === '-2' ||
                        isExamine === ''
                      "
                      size="small"
                      style="margin: 0 auto"
                      @click="changeCoverback(index)"
                    >
                      {{ $t("common.selectfile") }}
                    </el-button>
                  </el-upload>
                </div>
              </li>
            </ul>
            <el-upload
              v-if="flag && photoCoverList.length < 1"
              ref="coverVideo"
              :action="baseFileUrl"
              :file-list="photoCoverList"
              :headers="getToken()"
              :on-success="handSuccess"
              :show-file-list="false"
              class="upload-demo"
              drag
              list-type="picture-card"
              :before-upload="
                (file) => {
                  return coverBefore(file);
                }
              "
            >
              <div class="el-upload__text">{{ $t("common.selectfile") }}</div>
            </el-upload>
          </div>
          <p class="tishi">
            <!-- 格式：jpg, png, gif; 建议尺寸：693*462px; 大小：2M内；
             -->
            {{
              $t("common.uploadimg1", {
                format: "jpg, png, gif",
                recomsize: "693*462",
                filesize: "500kb",
              })
            }}
          </p>
        </el-form-item>

        <!-- 富文本-->
        <el-form-item :label="$t('news.newsContent') + ':'" prop="content">
          <template v-if="isExamine == 2 || isExamine == '0'">
                  
            <!-- <div v-html="sizeForm.content"></div> -->
             
            <div class="tinymce">
              <tinymce
                ref="column"
                contenteditable="false"
                v-model="sizeForm.content"
                :data="sizeForm.content"
                style="width: 800px"
              >
              </tinymce>
               
            </div>
          </template>

          <template v-else>
            <tinymce
              ref="column"
              v-model="sizeForm.content"
              :data="sizeForm.content"
              style="width: 800px"
            ></tinymce>
          </template>
        </el-form-item>
        <!-- 富文本-->
        <!-- 审核不通过原因 -->
        <div class="btn">
          <div v-show="isExamine == -1" class="why">
            {{ $t("common.noPass") }}
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">{{ sizeForm.cause }}</div>
              <router-link to="#"> {{ $t("active.cause") }}</router-link>
            </el-tooltip>
          </div>
        </div>
        <el-row>
          <button
            v-if="isExamine == '-2' || isExamine == '-1' || isExamine == ''"
            class="submit"
            @click="submit()"
            type="button"
          >
            {{ $t("common.submit") }}
          </button>
          <button
            type="button"
            v-if="isExamine == '-2' || isExamine == '-1' || isExamine == ''"
            class="save"
            @click="preserve()"
          >
            {{ $t("common.save") }}
          </button>
          <button type="button" v-if="isExamine == '0'" class="save" disabled>
            {{ $t("common.save") }}
          </button>
          <button
            v-if="isExamine === '2'"
            class="save"
            disabled="disabled"
            type="button"
          >
            {{ $t("active.inreview") }}
          </button>
          <button class="preview" type="button" @click="prenews()">
            {{ $t("common.preview") }}
          </button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import tinymce from "../../comment/tinymce.vue";
// import "@/static/tinymce/tinymce.js";
import { baseFileUrl, forMat } from "../../../../utils/common.js";
import { addnews, getOneInfo, submitnews } from "../../../../api/newCenter.js";
import headTop from "../../common/viewHead.vue";
import footBottom from "../../common/foot.vue";

export default {
  data() {
    return {
      baseFileUrl: baseFileUrl(),
      baseUrl: forMat(),
      picInfo: {},
      sizeForm: {
        newsTitle: "", //标题
        abstracts: "", //摘要
        coverPhoto: "", //封面
        content: "", //内容
        language: "zh_CN", //zh_CN  中英文切换
        createDate: "",
      },
      currentLength: 60,
      id: this.$route.query.id,
      upData: {},
      currentCoverIndex: "",
      flag: true,
      photoCoverList: [],
      reCovelist: [],
      editVisible: false,
      dateTimeNow: "",

      isExamine: "",
    };
  },
  computed: {
    rules() {
      var validatorContent = (rule, value, callback) => {
        const content = this.$refs.column.getContent();
        if (!content) {
          callback(new Error(this.$t("dialog.message11")));
        } else {
          callback();
        }
      };
      return {
        newsTitle: [
          {
            required: true,
            message: this.$t("dialog.message8"),
            trigger: "blur",
          },
        ],
        abstracts: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("dialog.message9"),
          },
        ],
        content: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("dialog.message10"),
          },
          { validator: validatorContent },
        ],
      };
    },
  },
  components: {
    tinymce,
    headTop,
    footBottom,
  },
  created() {
    this.getInfomation();
    if (this.id) {
      this.flag = false;
    }
  },
  methods: {
    //封面信息提示
    coverBefore(file) {
      const size = file.size / 1024 < 500;
      if (!size) {
        this.$message({ message: this.$t("dialog.message6"), type: "warning" });
        return false;
      }
    },
    inputArea() {
      if (this.sizeForm.abstracts.length < 60) {
        this.currentLength = 60 - this.sizeForm.abstracts.length;
      } else {
        this.currentLength = 0;
        this.sizeForm.abstracts = this.sizeForm.abstracts.slice(0, 60);
      }
    },
    //删除图片
    deleteImg() {
      this.sizeForm.coverPhoto = "";
      this.$forceUpdate();
    },
    //上传前校验
    beforeUpload(file) {
      let filehz = file.name.substring(file.name.lastIndexOf(".") + 1); //获取文件后缀
      if (filehz !== "jpg" && filehz !== "png" && filehz !== "gif") {
        this.$message({
          message: this.$t("dialog.message1"),
          type: "warning",
        });
        return false;
      }
      const limitSize = file.size / 1024 / 1024 < 2;
      if (!limitSize) {
        this.$message({
          message: this.$t("dialog.message7"),
          type: "warning",
        });
        return false;
      }
    },
    changeCoverback(index) {
      this.currentCoverIndex = index;
    },
    // 图片上传成功后
    handSuccess(file) {
      if (file.code == 200) {
        const { url } = file.data;
        this.sizeForm.coverPhoto = file.data.url;
        if (this.currentCoverIndex !== "") {
          // 修改封面的url
          this.photoCoverList[0].url = this.baseUrl + url;
          this.reCovelist[0].url = url;
        } else {
          if (url.indexOf("http") == -1) {
            url = this.baseUrl + url;
          }

          // 新增封面
          this.photoCoverList.push({
            url: url,
          });
          this.reCovelist.push({
            url: url,
          });
        }
        this.currentCoverIndex = "";
      }
    },
    handleError(file) {
      console.log(file, "图片上传失败");
    },
    getToken() {
      const a = localStorage.getItem("token");
      let token = {};
      token.token = a;
      return token;
    },
    async add(obj) {
      // const { data } = await addnews(obj);
    },
    submit() {
      // 提交接口
      this.reCovelist.map((item) => {
        this.sizeForm.coverPhoto = item.url;
      });
      this.sizeForm.content = this.$refs.column.getContent();
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitVefriy();
        } else {
        }
      });
    },
    async submitVefriy() {
      this.sizeForm.id = this.id;
      try {
        const { data } = await submitnews(this.sizeForm);
        if (data.code === 200) {
          this.$router.push("/backIndex/exhi_news");
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    // 保存修改和新增
    async preserve() {
      this.reCovelist.map((item) => {
        this.sizeForm.coverPhoto = item.url;
      });
      this.sizeForm.content = this.$refs.column.getContent();
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sumbitForm();
        } else {
        }
      });
    },
    async sumbitForm() {
      if (this.id) {
        this.sizeForm.id = this.id;
      }
      try {
        const { data } = await addnews(this.sizeForm);
        if (data.code === 200) {
          console.log(data, "dataaaaaaaa");
          this.$router.push("/backIndex/exhi_news");
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    // 获取单条信息内容
    async getInfomation() {
      if (this.id) {
        const params = {
          id: this.id,
        };
        try {
          const { data } = await getOneInfo(params);
          if (data.code === 200) {
            this.sizeForm = data.data;
            if (this.sizeForm.coverPhoto.indexOf("http") == -1) {
              this.sizeForm.coverPhoto = this.baseUrl + url;
            }
            this.photoCoverList.push({
              url: this.sizeForm.coverPhoto,
            });
            // console.log("请求成功之后的新闻数据", this.sizeForm);
            this.isExamine = data.data.auditFlag;
          }
        } catch (err) {
          this.$message.error(err);
        }
      }
    },
    // 返回上一页
    comBack() {
      this.$router.push("/backIndex/exhi_news");
    },
    // 预览新闻页
    prenews() {
      let dateTime;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      dateTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      this.dateTimeNow = dateTime;
      this.sizeForm.content = this.$refs.column.getContent();
      const news = {
        dateTimeNow: dateTime,
        sizeForm: this.sizeForm,
      };
      this.$store.commit("updatenews", news);

      console.log(this.sizeForm);
      let { href } = this.$router.resolve({
        name: "viewnews",
      });
      window.open(href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.tinymce {
  width: 800px;
  // height: 260px;
  // border: 1px solid red;
  pointer-events: none;

  z-index: 9999;
}
.imgBox {
  width: 100%;
  height: 100%;
  z-index: 9999;

  ul {
    overflow: hidden;
  }

  .upload-logo {
    text-align: center;
    width: 170px;
    height: 170px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    float: left;
    margin-left: 20px;

    img {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .tishi {
    margin-top: 30px;
    width: 509px;
  }
}

.news {
  box-sizing: border-box;
  background: white;
  padding: 18px 26px 70px 0;

  .title {
    height: 55px;
    padding-left: 26px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 35px;

    h3 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      cursor: pointer;

      .num1 {
        margin-left: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;

        i {
          font-style: normal;
          color: red;
        }
      }
    }

    button {
      width: 88px;
      height: 32px;
      border: 1px solid #006fb8;
      color: #006fb8;
      background: white;
      margin-left: 10px;
    }
  }

  .formedata {
    width: 600px;
    // margin: 0 auto;
    p {
      font-size: 12px;
      color: #999999;

      span {
        color: red;
      }
    }

    .upload-logo {
      text-align: center;
      width: 170px;
      height: 170px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 20px;

      img {
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    .tishi {
      margin-top: 30px;
      width: 420px;
    }

    button {
      width: 77px;
      height: 28px;
      border: none;
      border-radius: 2px;
      margin-right: 18px;
    }

    .btn {
      text-align: center;
      margin-left: 45px;

      .why {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff190c;
        line-height: 20px;
      }

      .item {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #006fb8;
        line-height: 20px;
      }
    }

    .el-row {
      // border: 1px solid red;
      margin-top: 20px;
      text-align: center;
    }

    .submit {
      background: #006fb8;

      color: white;
      margin-left: 26px;
    }

    .save {
      background: #006fb8;
      color: white;
    }

    .preview {
      background: #ffffff;
      border: 1px solid #d9d9d9;
      width: #666;
    }
  }
}
</style>
<style scoped>
.upload-demo >>> .el-upload-dragger {
  width: 225px;
  height: 173px;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px;
}

.upload-demo >>> .el-upload__text {
  width: fit-content;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  width: 108px;
  height: 32px;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 27px;
}
</style>
